import React from "react";
import "./SalonXp.css";
const SalonXp = () => {
  return (
    <div className="salonXpContainer">
      <h5>The SCENT Salon Experience</h5>
      <p>
        At SCENT Salon, we believe that getting a{" "}
        <a href="https://scentlifestyle.com/nails-salon">
          {" "}
          nail extension in Bangalore
        </a>{" "}
        should be a relaxing and enjoyable experience. From the moment you walk
        through our doors, you’ll be greeted by our friendly staff and treated
        to a luxurious salon environment. Our goal is to make sure you leave
        feeling pampered and looking fabulous.
      </p>
    </div>
  );
};

export default SalonXp;
